import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

/**
 * PD-17424 — how one user wants report money shown, kept on the server so it
 * follows them across devices and so a schedule they own can use it as its
 * default.
 *
 * `amountsMode`: `auto` rounds money the way the report cards already do
 * (tables without cents, tiles compact) and `exact` shows every cent. Stored
 * as text, read through `isReportAmountsMode`, so a value this code does not
 * know falls back to auto rather than breaking a report.
 *
 * One row per user, created on the first change.
 */
@Index('idx_report_user_setting_user', ['fkUserId'], { unique: true })
@Entity('report_user_setting')
export class ReportUserSettingEntity extends BaseEntity {
	/** Tenant-local `user._id`, the id the session's instance user carries. */
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('varchar', { name: 'amountsMode', length: 10, default: () => "'auto'" })
	public amountsMode!: string;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public user!: UserEntity;
}
